import React from 'react';
import { connect } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import Main from './Main';
import './App.css';

export class App extends React.Component {
  render() {
    return (
      <div className='app'>
        <Routes>
          <Route path='/auth/:token/:cloudauthEnv/:selfServiceEnv/*' element={<Main />} />
          <Route path='/*' element={<Main />} />
        </Routes>
      </div>
    );
  }
}

export default connect()(App);
